import { sortBy } from 'lodash-es';

import { services } from 'services/base';
import { PreferencesComponent, PreferencesMenuItemConfig, PreferencesMenuItemType } from 'types';
import { getMainConfig } from 'utils';

const getPreferencesDefaultItems = () => {
  const cookieItems = getMainConfig('cookie') || [];
  const cookieEnabled = cookieItems.length > 0;
  const darkModeAllowed = services.appFrame.theme.isDarkModeAllowed();
  const timezoneAllowed = services.appFrame.timezone.isTimezoneAllowed();
  const availableLanguages = services.appFrame.language.getAvailableLanguages();
  const showLanguageSelector = availableLanguages && availableLanguages.length > 1;
  const showAboutDialog = services.appFrame.about.modules.getItems().length > 1;
  const mainConfigItems = (getMainConfig('preferencesMenu') ?? []).map(({ type, ...item }) => ({
    type: type ?? PreferencesMenuItemType.CONFIG,
    ...item,
  })) as PreferencesMenuItemConfig[];
  const defaultItems: PreferencesMenuItemConfig[] = [];

  if (darkModeAllowed) {
    defaultItems.push({
      type: PreferencesMenuItemType.COMPONENT,
      Component: PreferencesComponent.DarkModeSelector,
      id: 'DarkModeSelector',
      order: 1000,
    });

    defaultItems.push({
      type: PreferencesMenuItemType.DIVIDER,
      id: '@Divider_1',
      order: 1100,
    });
  }

  if (timezoneAllowed) {
    defaultItems.push({
      type: PreferencesMenuItemType.COMPONENT,
      Component: PreferencesComponent.TimezoneSelector,
      id: 'TimezoneSelector',
      order: 1200,
    });
    defaultItems.push({
      type: PreferencesMenuItemType.DIVIDER,
      id: '@Divider_2',
      order: 1300,
    });
  }

  if (showLanguageSelector) {
    defaultItems.push({
      type: PreferencesMenuItemType.COMPONENT,
      Component: PreferencesComponent.LanguageSelector,
      id: 'LanguageSelector',
      order: 1400,
    });
    defaultItems.push({
      type: PreferencesMenuItemType.DIVIDER,
      id: '@Divider_3',
      order: 1500,
    });
  }

  if (showAboutDialog) {
    defaultItems.push({
      type: PreferencesMenuItemType.DIVIDER,
      id: '@Divider_4',
      order: 1900,
    });

    defaultItems.push({
      type: PreferencesMenuItemType.COMPONENT,
      Component: PreferencesComponent.AboutDialog,
      id: 'AboutDialog',
      order: 2000,
    });
  }

  if (cookieEnabled) {
    defaultItems.push({
      type: PreferencesMenuItemType.COMPONENT,
      Component: PreferencesComponent.CookieBanner,
      id: 'CookieSettings',
      order: 2200,
    });
  }

  return sortBy([...mainConfigItems, ...defaultItems], 'order');
};

const SERVICE_PREFIX = 'appFrame.preferences';

const initPreferencesServices = () => {
  services.registerCollection(SERVICE_PREFIX, getPreferencesDefaultItems());

  const updateDefaultItems = () => {
    services.appFrame.preferences.setDefaultItems(getPreferencesDefaultItems());
  };
  services.appFrame.theme.onDarkModeAllowedChange(updateDefaultItems);
  services.appFrame.language.onAvailableLanguagesChange(updateDefaultItems);
  services.appFrame.about.modules.onItemChange(updateDefaultItems);
  // TODO: consider to use coookie services and allow/disallow cookie settings
};

export default initPreferencesServices;
